import { PROFILE_GOAL, PROFILE_KEY } from '../../../../../models/profile/constants'
import { getActionStrReduxUtil } from '../../../../redux/utils/get-action-str'
import { REDUX_ACTION_PREFIX } from '../../../../redux/constants/action'
import { updateProfileAction } from '../../actions/update'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'
import { getCurrentOrCustomerProfileSelect } from '../../selectors/get-current-or-customer'
import { logUtil } from 'packages/src'
import { MACRONUTRIENT, MACRONUTRIENT_TO_CALORIES_PER_GRAM } from '../../../../meal'

// TODO adjust based on body type

const PROFILE_GOAL_TO_CALORIE_INTAKE_INCREASE = {
  [PROFILE_GOAL.LOSE_WEIGHT]: -300,
  [PROFILE_GOAL.GET_FIT]: 150,
  [PROFILE_GOAL.STAY_ACTIVE]: 0,
  [PROFILE_GOAL.BUILD_MUSCLE]: 150,
  [PROFILE_GOAL.GET_STRONGER]: 150
}

const PROFILE_GOAL_TO_MACRONUTRIENT_RATIO = {
  [PROFILE_GOAL.LOSE_WEIGHT]: {
    [PROFILE_KEY.DAILY_PROTEIN_INTAKE_PERCENTAGE_GOAL]: 40,
    [PROFILE_KEY.DAILY_FAT_INTAKE_PERCENTAGE_GOAL]: 35,
    [PROFILE_KEY.DAILY_CARBOHYDRATE_INTAKE_PERCENTAGE_GOAL]: 25
  },
  [PROFILE_GOAL.GET_FIT]: {
    [PROFILE_KEY.DAILY_PROTEIN_INTAKE_PERCENTAGE_GOAL]: 40,
    [PROFILE_KEY.DAILY_FAT_INTAKE_PERCENTAGE_GOAL]: 20,
    [PROFILE_KEY.DAILY_CARBOHYDRATE_INTAKE_PERCENTAGE_GOAL]: 40
  },
  [PROFILE_GOAL.BUILD_MUSCLE]: {
    [PROFILE_KEY.DAILY_PROTEIN_INTAKE_PERCENTAGE_GOAL]: 40,
    [PROFILE_KEY.DAILY_FAT_INTAKE_PERCENTAGE_GOAL]: 20,
    [PROFILE_KEY.DAILY_CARBOHYDRATE_INTAKE_PERCENTAGE_GOAL]: 40
  },
  [PROFILE_GOAL.GET_STRONGER]: {
    [PROFILE_KEY.DAILY_PROTEIN_INTAKE_PERCENTAGE_GOAL]: 40,
    [PROFILE_KEY.DAILY_FAT_INTAKE_PERCENTAGE_GOAL]: 20,
    [PROFILE_KEY.DAILY_CARBOHYDRATE_INTAKE_PERCENTAGE_GOAL]: 40
  },
  [PROFILE_GOAL.STAY_ACTIVE]: {
    [PROFILE_KEY.DAILY_PROTEIN_INTAKE_PERCENTAGE_GOAL]: 35,
    [PROFILE_KEY.DAILY_FAT_INTAKE_PERCENTAGE_GOAL]: 30,
    [PROFILE_KEY.DAILY_CARBOHYDRATE_INTAKE_PERCENTAGE_GOAL]: 35
  }
}

const PERCENTAGE_KEY_TO_GRAM_KEY = {
  [PROFILE_KEY.DAILY_PROTEIN_INTAKE_PERCENTAGE_GOAL]: PROFILE_KEY.DAILY_PROTEIN_INTAKE_GOAL_IN_GRAM,
  [PROFILE_KEY.DAILY_CARBOHYDRATE_INTAKE_PERCENTAGE_GOAL]: PROFILE_KEY.DAILY_CARBOHYDRATE_INTAKE_GOAL_IN_GRAM,
  [PROFILE_KEY.DAILY_FAT_INTAKE_PERCENTAGE_GOAL]: PROFILE_KEY.DAILY_FAT_INTAKE_GOAL_IN_GRAM
}

const PERCENTAGE_KEY_TO_MACRONUTRIENT = {
  [PROFILE_KEY.DAILY_PROTEIN_INTAKE_PERCENTAGE_GOAL]: MACRONUTRIENT.PROTEIN,
  [PROFILE_KEY.DAILY_CARBOHYDRATE_INTAKE_PERCENTAGE_GOAL]: MACRONUTRIENT.CARBS,
  [PROFILE_KEY.DAILY_FAT_INTAKE_PERCENTAGE_GOAL]: MACRONUTRIENT.FAT
}

export function updateDailyCalorieIntakeBasedOnGoalProfileAction () {
  return (dispatch, getState) => {
    const key = PROFILE_KEY.DAILY_CALORIE_INTAKE_GOAL
    const profile = getCurrentOrCustomerProfileSelect(getState())
    const dailyCalorieIntakeGoal = getValueReduxUtil(profile, key)

    if (dailyCalorieIntakeGoal) {
      logUtil('updateDailyCalorieIntakeBasedOnGoalProfileAction').warn('[noop] dailyCalorieIntakeGoal already set')
      return
    }

    const goal = getValueReduxUtil(profile, PROFILE_KEY.GOAL)
    logUtil('updateDailyCalorieIntakeBasedOnGoalProfileAction').debug('profile=', profile)
    const calorieIntakeIncrease = PROFILE_GOAL_TO_CALORIE_INTAKE_INCREASE[goal] || 0
    // if (!calorieIntakeIncrease) {
    //   logUtil('updateDailyCalorieIntakeBasedOnGoalProfileAction').warn('[noop] calorieIntakeIncrease not found for goal=', goal)
    //   return
    // }

    const tdee = getValueReduxUtil(profile, PROFILE_KEY.TOTAL_ENERGY_EXPENDITURE)
    if (!tdee) {
      logUtil('updateDailyCalorieIntakeBasedOnGoalProfileAction').warn('[noop] tdee not defined')
      return
    }

    const value = tdee + calorieIntakeIncrease
    const updates = { [key]: value }
    const macronutrientRatio = PROFILE_GOAL_TO_MACRONUTRIENT_RATIO[goal]
    Object.keys(macronutrientRatio).forEach(key => {
      const percentage = macronutrientRatio[key]
      updates[key] = percentage
      const gramKey = PERCENTAGE_KEY_TO_GRAM_KEY[key]
      const macronutrient = PERCENTAGE_KEY_TO_MACRONUTRIENT[key]
      updates[gramKey] = ((percentage * value) / 100) / MACRONUTRIENT_TO_CALORIES_PER_GRAM[macronutrient]
    })

    dispatch(
      updateProfileAction({
        type: getActionStrReduxUtil(
          REDUX_ACTION_PREFIX.UPDATE,
          key,
          value
        ),
        payload: {
          updates
        }
      })
    )
  }
}
